import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { withStore } from "@searchspring/snap-preact-components";

import "./Header.css";

import { SearchInput } from "../SearchInput/SearchInput"


@withStore
@observer
export class Header extends Component {
  render() {
    const { pagination, search, custom } = this.props.store;

    return (
      <header class={`ss-header-container page-width ${pagination.totalResults > 0 ? 'ss-header-results-found' : 'ss-header-results-not-found'}`}>
          {pagination.totalResults ? (
            <>
              <span class="ss-pre-title eyebrow eyebrow-medium">{window.Resources.searchspring.results.preTitle}</span>
              <p class="ss-title ss-results-title headline-large">
                {window.Resources.searchspring.results.weFoundPrefix}
                <span class="ss-results-count-total">{pagination.totalResults}</span>
                {`${pagination.totalResults == 1 ? `${window.Resources.searchspring.results.weFoundResultsSingular}` : `${window.Resources.searchspring.results.weFoundResultsPlural}`}`}
                {search?.query && (
                  <span>
                    {window.Resources.searchspring.results.weFoundResultsFor}
                    <span class="ss-results-query">"{search.query.string}"</span>
                  </span>
                )}
              </p>
            </>
          ) : (
            pagination.totalResults === 0 && (
              <>
                <span class="ss-pre-title eyebrow eyebrow-medium">{window.Resources.searchspring.results.preTitle}</span>
                <p class="ss-title ss-results-title ss-no-results-title headline-large">
                  {search?.query ? (
                    <>
                      <span>
                      {window.Resources.searchspring.results.noResultsHeading} {' '}
                        <span class="ss-results-query">
                            "{search.query.string}"
                        </span>{' '}
                      </span>
                      <span class="ss-results-header-message body-medium">
                        {window.Resources.searchspring.results.noResultsMessage}
                      </span>
                      <SearchInput/>
                    </>
                  ) : (
                    <span>No results found.</span>
                  )}
                </p>
              </>
            )
          )}
      </header>
    );
  }
}